// extracted by mini-css-extract-plugin
export default {"container":"eL-z","topReviewHeading":"fL-z","criticalReview":"gL-z","favorableReview":"hL-z","vsSeparator":"iL-z"};